import React, { useState } from 'react';

import { withFirebase } from '../../firebase';
import data from '../../../constants/matchSummary.json'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import uuid from 'react-uuid';
import MatchSummaryItem from './MatchSummaryItem';

const MatchesListFormSummary = (props) => {

    const { eventMap, teams, teamAUid, teamBUid, players } = props;
    const [teamSelectedUid, setTeamSelectedUid] = useState('');
    const [playerSelectedUid, setPlayerSelectedUid] = useState('');
    const [eventSelected, setEventSelected] = useState('');
    const [minuteValue, setMinuteValue] = useState(null);

    const { _events } = data;

    const matchTeams = [];
    const teamA = teams.find((item) => item.uid === teamAUid);
    const teamB = teams.find((item) => item.uid === teamBUid);
    if (teamA != null) matchTeams.push(teamA)
    if (teamB != null) matchTeams.push(teamB)

    const playersTeam = players.filter((item) => item.teamUid == teamSelectedUid && item.position !== 'Director Técnico');

    const disablePlayerSelect = !(playersTeam && playersTeam.length > 0)
    const disableEventSelect = false //playerSelectedUid == ''
    const disableMinuteValue = eventSelected == '' || eventSelected == 'valla_invicta';

    const addEvent = () => {
        const invalid = teamSelectedUid == '' || playerSelectedUid == ''
            || eventSelected == '' || (eventSelected != 'valla_invicta' && minuteValue == '');
        if (!invalid) {
            const eventUid = uuid();
            const event = {
                uid: eventUid,
                teamUid: teamSelectedUid,
                playerUid: playerSelectedUid,
                event: eventSelected,
                minute: eventSelected != 'valla_invicta' ? minuteValue : 999999
            }

            const eventMapCopy = Object.assign({}, eventMap);
            eventMapCopy[eventUid] = event;
            props.updateEventMap(eventMapCopy, event, true);

            // setTeamSelectedUid('');
            setPlayerSelectedUid('');
            setEventSelected('');
            setMinuteValue('');
        }
    }

    const removeEvent = (event) => {
        const eventMapCopy = Object.assign({}, eventMap);
        delete eventMapCopy[event.uid];
        props.updateEventMap(eventMapCopy, event, false);
    }

    const invalid = teamSelectedUid == '' || playerSelectedUid == ''
        || eventSelected == '' || (eventSelected != 'valla_invicta' && (minuteValue == null || minuteValue == ''));

    playersTeam.sort((a, b) => {
        return ((a.number || 999999) - (b.number || 999999)) || (a.name.localeCompare(b.name));
    })

    return (
        <div className="row m-0">
            <div className="col row justify-content-center pl-0 pr-0 m-0 mt-1">

                {/* Teams select --------------------*/}
                <div className="col p-1">
                    {/* <label className="small text-secondary mb-0 ml-1" htmlFor="teamSelected">Equipo</label> */}
                    <select value={teamSelectedUid || ''} onChange={(e) => setTeamSelectedUid(e.target.value)} className="form-control form-control-sm text-dark" id="teamSelected">
                        <option className="text-black-50 font-italic" value="">Equipo...</option>
                        {matchTeams.map(team => <option key={team.uid} value={team.uid}>{team.title}</option>)}
                    </select>
                </div>

                <div className="col p-1">
                    {/* <label className="small text-secondary mb-0 ml-1" htmlFor="player">Jugador</label> */}
                    <select disabled={disablePlayerSelect} value={playerSelectedUid || ''} onChange={(e) => setPlayerSelectedUid(e.target.value)} className="form-control form-control-sm text-dark" id="player">
                        <option className="text-black-50 font-italic" value="">Jugador...</option>
                        {playersTeam.map(player => <option key={player.uid} value={player.uid}>{`${player.number || '-'} ${player.name}`}</option>)}
                    </select>
                </div>

                <div className="w-100"></div>

                <div className="col p-1">
                    {/* <label className="small text-secondary mb-0 ml-1" htmlFor="event">Evento</label> */}
                    <select disabled={disableEventSelect} value={eventSelected || ''} onChange={(e) => setEventSelected(e.target.value)} className="form-control form-control-sm text-dark" id="event">
                        <option className="text-black-50 font-italic" value="">Evento...</option>
                        {Object.keys(_events).map((key, i) =>
                            <option key={key} value={key}>{_events[key]}</option>)
                        }
                    </select>
                </div>

                {/* Match result --------------------*/}
                <div className="col-auto p-1">
                    <input disabled={disableMinuteValue} className="form-control form-control-sm text-center" id="minute" style={{ width: 60 }}
                        value={minuteValue == null ? '' : minuteValue} type="number" min="0" max="130" placeholder="min'"
                        onChange={(e) => setMinuteValue(e.target.value != '' ? parseInt(e.target.value, 10) : null)} />
                </div>

                <div className="col-auto p-1">
                    <button disabled={invalid} type="button" onClick={addEvent} className="btn btn-sm btn-primary">
                        <FontAwesomeIcon className="mr-2" icon={faPlus} />
                        <span>Añadir</span>
                    </button>
                </div>

                <div className="w-100"></div>

                <div className="col bg-light small border mr-1 mt-1 ml-1 rounded-lg p-0 " style={{ height: 238, overflowY: 'scroll' }}>
                    <MatchSummaryItem teamAUid={teamAUid} players={players} eventMap={eventMap} removeEvent={removeEvent} />
                </div>

            </div>
        </div>
    )
}

export default withFirebase(MatchesListFormSummary);
